export default __webpack_public_path__ + "static/media/popup_wr.e0e65564.png";